<template>
  <div
    v-if="result == null || result.length == 0"
    class="p-4 text-center w-100"
  >
    <h4>Not Found</h4>
  </div>
</template>

<script>
    export default {
        name: "ResultNotFound",
        props: ['result']
    }
</script>

<style scoped>

</style>